import {i18n} from 'i18next';
import {useContext} from 'react';
import {I18nContext} from 'react-i18next';

export function useI18n(): i18n {
  return useContext(I18nContext).i18n;
}
